import { render } from "./LangButton.vue?vue&type=template&id=09618e6f&scoped=true"
import script from "./LangButton.vue?vue&type=script&lang=js"
export * from "./LangButton.vue?vue&type=script&lang=js"

import "./LangButton.vue?vue&type=style&index=0&id=09618e6f&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09618e6f"]])

export default __exports__